export default {
  ru: {
    openEvent: 'Открыть данные события',
    eventData: 'Данные события',
    dataView: 'Режим просмотра данных',
    allFields: 'Все данные ({count})',
    onlyChanges: 'Только изменения ({count})',
    snapshotHint:
      'Сохранённые значения на момент события, а не текущая карточка.',
    primary: 'Первичный',
    repeat: 'Повторный',
    title: 'Поток событий',
    subtitle: 'Изменения данных из МИС и результаты обработки сценариями.',
    refresh: 'Обновить',
    all: 'Все',
    source: 'Источник',
    entity: 'Сущность',
    event: 'Событие',
    status: 'Обработка',
    from: 'С даты',
    to: 'По дату',
    reset: 'Сбросить',
    when: 'Дата события',
    patient: 'Пациент',
    runs: 'Запуски',
    details: 'Подробнее',
    close: 'Закрыть',
    loading: 'Загрузка…',
    error: 'Не удалось загрузить события. Попробуйте ещё раз.',
    empty: 'По выбранным фильтрам событий нет.',
    total: 'Всего: {count}',
    page: 'Страница {page}',
    next: 'Вперёд',
    back: 'Назад',
    received: 'Последние данные MRES3: {date}',
    receivedAt: 'Получено',
    occurredAt: 'Произошло',
    field: 'Поле',
    before: 'До',
    after: 'После',
    unknown: 'Не сохранено',
    blank: 'Пусто',
    yes: 'Да',
    no: 'Нет',
    changes: 'Изменения',
    context: 'Данные запуска',
    noChanges: 'Значения полей не изменились.',
    history: 'История импортирована без повторного запуска сценариев.',
    incomplete:
      'Для этого старого события сохранился только факт получения. Прежние значения полей неизвестны.',
    lastKnown:
      'Источник не передал полный снимок «до». Показаны последние известные значения в MedUp.',
    noRuns: 'Запусков сценариев по этому событию нет.',
    version: 'Версия {version}',
    technical: 'Исходные данные (JSON)',
    sources: { mres3: 'MRES3', scheduler: 'Расписание', generic: 'Интеграция' },
    entities: {
      patients: 'Пациенты',
      appointments: 'Записи на приём',
      appointment_services: 'Товары записей на приём',
      patient_phones: 'Телефоны пациентов',
      staff: 'Сотрудники',
      branches: 'Филиалы',
      business_units: 'Подразделения',
      departments: 'Отделения',
      workplaces: 'Рабочие места',
      services: 'Товары и услуги',
      appointment_stages: 'Статусы записей',
      specializations: 'Специализации',
      appointment_reasons: 'Поводы назначения',
      destination_types: 'Типы назначений',
      resources: 'Ресурсы',
      diagnoses: 'Диагнозы',
      patient_statuses: 'Статусы пациентов',
      financial_sources: 'Источники финансирования',
      payment_categories: 'Категории платежей',
      advertisements: 'Реклама',
      financial_sectors: 'Финансовые участки',
      service_sections: 'Разделы услуг',
    },
    events: {
      created: 'Создано',
      updated: 'Изменено',
      deleted: 'Удалено',
      changed: 'Изменение данных',
      response: 'Ответ пациента',
      scheduled: 'Запуск по расписанию',
    },
    statuses: {
      pending: 'Ожидает обработки',
      retrying: 'Повторная обработка',
      processed: 'Обработано',
      suppressed: 'История · без запуска',
      failed: 'Ошибка обработки',
    },
    outcomes: {
      dispatched: 'Сценарии запущены',
      scheduled: 'Запуск по расписанию',
      no_matching_trigger: 'Нет подходящего типа запуска',
      no_matching_scenario: 'Нет подходящего сценария',
      outside_test_allowlist: 'Пациент вне тестового списка',
      runtime_disabled: 'Автоматизация выключена',
      history_import: 'История · без запуска',
      invalid_identity: 'Не удалось определить запись',
      patient_not_found: 'Пациент не найден',
      ambiguous_patient: 'Пациент определён неоднозначно',
      contact_not_found: 'Контакт не найден',
      ambiguous_contact: 'Контакт определён неоднозначно',
      appointment_patient_changed: 'Пациент в записи изменился',
      recipient_identity_unresolved: 'Не удалось однозначно определить контакт',
    },
    runStatuses: {
      active: 'Выполняется',
      waiting: 'Ожидает',
      done: 'Завершён',
      exited: 'Завершён',
      failed: 'Ошибка',
      cancelled: 'Отменён',
      stopped: 'Остановлен',
      completed: 'Завершён',
    },
  },
  en: {
    openEvent: 'Open event data',
    eventData: 'Event data',
    dataView: 'Data view',
    allFields: 'All fields ({count})',
    onlyChanges: 'Changes only ({count})',
    snapshotHint:
      'Saved values at the time of the event, not the current record.',
    primary: 'First-time',
    repeat: 'Returning',
    title: 'Event stream',
    subtitle: 'Source data changes and scenario processing results.',
    refresh: 'Refresh',
    all: 'All',
    source: 'Source',
    entity: 'Entity',
    event: 'Event',
    status: 'Processing',
    from: 'From',
    to: 'Through',
    reset: 'Reset',
    when: 'Event time',
    patient: 'Patient',
    runs: 'Runs',
    details: 'Details',
    close: 'Close',
    loading: 'Loading…',
    error: 'Could not load events. Please retry.',
    empty: 'No events match these filters.',
    total: 'Total: {count}',
    page: 'Page {page}',
    next: 'Next',
    back: 'Back',
    received: 'Latest MRES3 data: {date}',
    receivedAt: 'Received',
    occurredAt: 'Occurred',
    field: 'Field',
    before: 'Before',
    after: 'After',
    unknown: 'Not recorded',
    blank: 'Empty',
    yes: 'Yes',
    no: 'No',
    changes: 'Changes',
    context: 'Run context',
    noChanges: 'No field values changed.',
    history: 'History imported without restarting scenarios.',
    incomplete:
      'Only receipt metadata is available for this historical event. Previous field values were not retained.',
    lastKnown:
      'The source did not provide a complete before snapshot. Last known MedUp values are shown.',
    noRuns: 'No scenario runs for this event.',
    version: 'Version {version}',
    technical: 'Source data (JSON)',
    sources: { mres3: 'MRES3', scheduler: 'Schedule', generic: 'Integration' },
    entities: {
      patients: 'Patients',
      appointments: 'Appointments',
      appointment_services: 'Appointment products',
      patient_phones: 'Patient phones',
      staff: 'Staff',
      branches: 'Branches',
      business_units: 'Business units',
      departments: 'Departments',
      workplaces: 'Workplaces',
      services: 'Products and services',
      appointment_stages: 'Appointment statuses',
      specializations: 'Specialties',
      appointment_reasons: 'Appointment reasons',
      destination_types: 'Destination types',
      resources: 'Resources',
      diagnoses: 'Diagnoses',
      patient_statuses: 'Patient statuses',
      financial_sources: 'Financial sources',
      payment_categories: 'Payment categories',
      advertisements: 'Advertisements',
      financial_sectors: 'Financial sectors',
      service_sections: 'Service sections',
    },
    events: {
      created: 'Created',
      updated: 'Updated',
      deleted: 'Deleted',
      changed: 'Data changed',
      response: 'Patient response',
      scheduled: 'Scheduled run',
    },
    statuses: {
      pending: 'Pending',
      retrying: 'Retrying',
      processed: 'Processed',
      suppressed: 'History · no replay',
      failed: 'Processing failed',
    },
    outcomes: {
      dispatched: 'Scenarios started',
      scheduled: 'Scheduled run',
      no_matching_trigger: 'No matching trigger type',
      no_matching_scenario: 'No matching scenario',
      outside_test_allowlist: 'Outside test allowlist',
      runtime_disabled: 'Automation disabled',
      history_import: 'History · no replay',
      invalid_identity: 'Record identity unresolved',
      patient_not_found: 'Patient not found',
      ambiguous_patient: 'Ambiguous patient',
      contact_not_found: 'Contact not found',
      ambiguous_contact: 'Ambiguous contact',
      appointment_patient_changed: 'Appointment patient changed',
      recipient_identity_unresolved: 'Recipient identity unresolved',
    },
    runStatuses: {
      active: 'Running',
      waiting: 'Waiting',
      done: 'Completed',
      exited: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      stopped: 'Stopped',
      completed: 'Completed',
    },
  },
};
